import React from "react";

import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {NewSearchWidgetSportsFilterListItem} from "./new-search-widget.sports-filter.list-item";
import {NewSearchWidgetSportKeyboardClickComposer} from "../../composers/new-search-widget.sport-keyboard-click.composer";

export const NewSearchWidgetSportsFilterList = NewSearchWidgetSportKeyboardClickComposer(({controller, highlightedItemIndex, setHighlightedItemIndex, isDropdownOpen, sportsList, onClick}) => {
  return isDropdownOpen ? <div className={classNames(styles.sports_list)}>
    {
      sportsList?.map((sport, index) => <NewSearchWidgetSportsFilterListItem
        key={sport.id}
        sport={sport}
        controller={controller}
        onClick={onClick}
        onMouseEnter={() => setHighlightedItemIndex(index)}
        isHighlighted={highlightedItemIndex === index}
      />)
    }
  </div> : null
});
